import React from "react";
import "./assets/css/App.css";
import Home from "./pages/home/index.tsx";
import Footer from "./layouts/footer.tsx";
import NavBar from "./layouts/navBar.tsx";
import Login from "./pages/login/index.jsx";
import Pastors from "./pages/pastors/index.tsx";
import About from "./pages/about/index.jsx";
import Nuevo from "./pages/nuevo/index.jsx";
import Ofrenda from "./pages/ofrenda/index.jsx";
import Location from "./pages/location/index.jsx";
import Anuncios from "./pages/anuncios/index.jsx";
import Recursos from "./pages/recursos/index.jsx";



import {
  BrowserRouter as Router,
  Route,
  Routes,
  Outlet,
  useLocation,
} from "react-router-dom";
import { createTheme, responsiveFontSizes } from "@mui/material";
import { ThemeProvider } from "@emotion/react";
import Dashboard from "./pages/dashboard/index.jsx";
import Clases from "./pages/dashboard/clases/index.jsx";
// AUTHENTICATION FILES
import { AuthProvider } from "./context/AuthContext.js";
import ProtectedRoute from "./ProtectedRoute.js";

// inpiration sites: https://www.austinstone.org/, https://www.motivation.church/about, https://www.brooklake.org/

let theme = createTheme({
  typography: {
    fontFamily: "Helvetica",
    h1: {
      fontWeight: 600,
      fontSize: "4.5rem", // 72px (desktop)
      [`@media (max-width:768px)`]: {
        fontSize: "3.5rem", // 56px (tablet)
      },
      [`@media (max-width:480px)`]: {
        fontSize: "2.5rem", // 40px (mobile)
      },
    },
    h2: {
      fontSize: "3rem", // 48px (desktop)
      marginTop: 0,
      marginBottom: "16px",
      fontWeight: 600,
      lineHeight: 1.2,
      [`@media (max-width:768px)`]: {
        fontSize: "1.5rem", // 24px (tablet)
      },
      [`@media (max-width:480px)`]: {
        fontSize: "1.2rem", // 19.2px (mobile)
      },
    },
    subtitle1: {
      fontSize: "1rem", // 24px (desktop)
      fontWeight: 500,
      lineHeight: 1.2,
      color: "var(--primary-color)",
      [`@media (max-width:768px)`]: {
        fontSize: "1rem", // 19.2px (tablet)
        padding: "1rem",
      },
      [`@media (max-width:480px)`]: {
        fontSize: "1.0rem", // 16px (mobile)
        padding: "1rem",
      },
    },

    body1: {
      fontSize: "1.125rem", // 18px (desktop),
      color: "var(--primary-color)",
      [`@media (max-width:768px)`]: {
        fontSize: "1.0rem", // 16px (tablet)
        textAlign: "left",
      },
      [`@media (max-width:480px)`]: {
        fontSize: "0.9rem", // 14.4px (mobile)
        textAlign: "left",

      },
    },
    body2: {
      fontSize: "1.125rem", // 18px (desktop),
      color: "var(--background-white-color)",
      [`@media (max-width:768px)`]: {
        fontSize: "1.0rem", // 16px (tablet)
        textAlign: "left",

      },
      [`@media (max-width:480px)`]: {
        fontSize: "0.9rem", // 14.4px (mobile)
        textAlign: "left",

      },
    },
  },
});

theme = responsiveFontSizes(theme);

// ScrollToTop component to handle scroll behavior on navigation
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function Layout() {
  return (
    <ThemeProvider theme={theme}>
      <NavBar />
      <Outlet />
      <Footer />
    </ThemeProvider>
  );
}

function App() {
  return (
    <Router>
      <AuthProvider>
        <div className="App">
          <ScrollToTop />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/pastores" element={<Pastors />} />
              <Route path="/anuncios" element={<Anuncios />} />
              <Route path="/nosotros" element={<About />} />
              <Route path="/soy-nuevo" element={<Nuevo />} />
              <Route path="/ofrenda" element={<Ofrenda />} />
              <Route path="/locacion" element={<Location />} />
              <Route path="/recursos" element={<Recursos />} />
            </Route>

            {/* USER MUST BE AUTHENTICATED TO ACCESS DASHBOARD */}
            <Route>
              <Route path="/login" element={<Login />} />
              {/* //allow nested routes */}
              <Route
                path="/dashboard/*"
                element={<ProtectedRoute element={<Dashboard />} />}
              />
              <Route
                path="/clases"
                element={<ProtectedRoute element={<Clases />} />}
              />
            </Route>
          </Routes>
        </div>
      </AuthProvider>
    </Router>
  );
}

export default App;
